import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import { sortByName } from "../../utils/sortByName";

const getTermsData = createAsyncThunk("api/terms", async (token) => {
  try {
    const response = await axios.get("/dashboard/terms-and-condition", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const TermsDataSlice = createSlice({
  name: "Terms",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTermsData.fulfilled, (state, action) => {
        state.data = sortByName(action.payload);
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getTermsData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getTermsData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getTermsData };
export default TermsDataSlice.reducer;
